import { render, staticRenderFns } from "./main-recruitment.vue?vue&type=template&id=71f37122&scoped=true&"
import script from "./main-recruitment.vue?vue&type=script&lang=js&"
export * from "./main-recruitment.vue?vue&type=script&lang=js&"
import style0 from "./main-recruitment.vue?vue&type=style&index=0&id=71f37122&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f37122",
  null
  
)

export default component.exports